var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsterisk = function SvgAsterisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "currentColor",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99908 0.179688V7.44669L16.2931 3.81369L17.2931 5.54569L11.0001 9.17869L17.2931 12.8137L16.2931 14.5457L9.99908 10.9117V18.1797H7.99908V10.9117L1.70508 14.5457L0.705078 12.8137L6.99808 9.17969L0.705078 5.54569L1.70508 3.81369L7.99908 7.44669V0.179688H9.99908Z"
  })));
};
export default SvgAsterisk;